// extracted by mini-css-extract-plugin
module.exports = {"btn":"LoginToAnswerButton_btn__1wHkS","text":"LoginToAnswerButton_text__3vbfb","sending":"LoginToAnswerButton_sending__2b__m"};